import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxJsonViewerComponent } from './ngx-json-viewer/ngx-json-viewer';
import { MappingDialogComponent } from './mapping-dialog/mapping-dialog';
//Angular material imports
import { MatSelectModule,MatOptionModule,MatFormFieldModule } from '@angular/material';
import { MatButtonModule, MatCheckboxModule, MatInputModule } from '@angular/material';
import { MatDialogModule, TooltipPosition, MatRadioModule } from '@angular/material';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
	declarations: [
        NgxJsonViewerComponent,
	    MappingDialogComponent
	],
	imports: [
	    CommonModule,
	    MatButtonModule,
	    MatCheckboxModule,
        MatDialogModule,
        MatRadioModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule
	],
	exports: [
	    NgxJsonViewerComponent,
	    MappingDialogComponent
	],
    entryComponents: [
        MappingDialogComponent],
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts